import React from 'react';
import Carousel from '@hpstellar/core/Carousel';
import CollapseWrapper from '@hpstellar/core/CollapseWrapper';

import withPageComponents from '../../../page/components/with-page-components';
import ProductCard from '../../../product/components/product-card';
import { getProductClickMetrics } from '../../../metrics/metrics-helpers';

import './upsell.less'



const getSlickSettings = () => {
    const settings = {
        dots: true,
        draggable: false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        className: 'upsellCarousel',
        nextArrowClassName: 'upsellArrowNext',
        prevArrowClassName: 'upsellArrowPrev',
        lazyLoad: 'ondemand',
        responsive: [4.25, 3.5, 2.5, 2, 1.5, 1].map(slideCount => {
            const slidesToShow = slideCount;
            return {
                breakpoint: slidesToShow * 548,
                settings: {
                    draggable: slidesToShow < 3,
                    slidesToShow,
                    slidesToScroll: Math.floor(slidesToShow),
                    arrows: slidesToShow > 1,
                    dots: true,
                    infinite: false
                }
            }
        })
    }
    return settings;
}


const pdpUpSell = ({ pdpUpsell, product }) => {
    const { productsList } = pdpUpsell || {};
    const baseSku = product && product.sku;
    if (productsList && productsList.length > 0) {
        return (
            <CollapseWrapper
                title={'Similar Products'}
                desktopTitle={'Similar Products'}
                className={'pdp-upsell'}
                isStatic={true}
            >
                <Carousel
                    {...getSlickSettings()}
                >
                    {productsList.map((product, idx) => {
                        let productClickMetrics = getProductClickMetrics({ product, position: idx + 1, useAttributes: true, list: 'pdp-similar-prod' });

                        let ctaMetrics = {
                            list: 'pdp-similar-prod'
                        };
                        let popupConfig = {
                            ctaMetrics: {
                                list: 'pdp-cross-sell'
                            },
                            productClickMetrics: getProductClickMetrics({ product, position: idx + 1, useAttributes: true, list: 'pdp-cross-sell' })
                        }
                        return <ProductCard baseProductSku={baseSku} popupConfig={popupConfig} xsellType='pdp-similar-prod' ctaMetrics={ctaMetrics} key={product.sku} product={product} productClickMetrics={productClickMetrics} ctaMetrics={ctaMetrics} templateKey='pdp' />
                    })}
                </Carousel>
            </CollapseWrapper>
        );
    }
    return null;
}

export default withPageComponents(pdpUpSell, { components: ['pdpUpsell', 'product'] })
